import React, { useState, useEffect, useRef } from "react";
import Alert from "./Alert";
import { registerAlertHandler } from "../../_services/alertService";

const AUTO_CLOSE_MS = 3000;

const GlobalAlert = () => {
    const [alert, setAlert] = useState(null);
    const timerRef = useRef(null);

    useEffect(() => {
        registerAlertHandler((newAlert) => {
            // Clear any existing timer before setting a new alert
            if (timerRef.current) clearTimeout(timerRef.current);
            setAlert(newAlert);

            if (newAlert) {
                timerRef.current = setTimeout(() => {
                    setAlert(null);
                    timerRef.current = null;
                }, AUTO_CLOSE_MS);
            }
        });

        return () => {
            registerAlertHandler(null);
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);

    const close = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setAlert(null);
    };

    return (
        <Alert
            show={!!alert}
            type={alert?.type}
            title={alert?.title}
            message={alert?.message}
            confirmText={alert?.confirmText ?? "OK"}
            onConfirm={close}
            onCancel={close}
        />
    );
};

export default GlobalAlert;
